import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Modal } from '@saatva-bits/pattern-library.components.modal'
import { iconsPath } from '@/config/globals'

import styles from './styles.module.scss'

const ExtendModal = ({ isExtendModalVisible, setIsExtendModalVisible }) => {
    const titleClass = classNames('u-flexDisplay', 't-bold', styles.extendTitle)
    const itemClass = classNames('u-flexDisplay', styles.extendItem)

    const extendPlanUrl = 'https://customers.extend.com/en-US/plan_details/A0-FURSV-10y?storeId=34ff700d-2ae6-4e08-b07a-0a0c62b32d93'
    
    return (
        <Modal
            type='popup'
            isModalVisible={isExtendModalVisible}
            onModalClose={() => setIsExtendModalVisible(false)}
            className={styles.extendModal}
            modalLabel='Extend'
        >
            <div className={titleClass}>
                <img src={`${iconsPath}/extend/icon-extend.svg`} alt="extend" className={styles.extendModalExtendLogo} />
                &nbsp;&nbsp;+&nbsp;&nbsp;
                <img src={`${iconsPath}/saatva-logo.svg`} alt="saatva" className={styles.extendModalSaatvaLogo} />
            </div>
            <div className='body'>
                <p className={styles.extendDescription}>
                    Life happens. Enjoy peace of mind knowing your mattress is protected for 10 years from accidental stains & damage.
                </p>
                <p className={styles.extendDescription}>
                    This plan covers:
                </p>
                <ul>
                    <li className={itemClass}>
                        <img src={`${iconsPath}/extend/u-icon-repairs.svg`} alt="repair" />
                        <span className={styles.extendItemClass}>Hassle-free repairs at no additional cost</span>
                    </li>
                    <li className={itemClass}>
                        <img src={`${iconsPath}/extend/u-icon-damage.svg`} alt="damage" />
                        <span className={styles.extendItemClass}>Accidental damage from cuts & punctures</span>
                    </li>
                    <li className={itemClass}>
                        <img src={`${iconsPath}/extend/u-icon-fluids.svg`} alt="fluids" />
                        <span className={styles.extendItemClass}>Stains from food, drinks & bodily fluids</span>
                    </li>
                    <li className={itemClass}>
                        <a className={styles.extendUrlLink} href={extendPlanUrl} target="_blank" rel="noreferrer noopener">See protection plan details &  FAQs</a>
                    </li>
                </ul>
            </div>
        </Modal>
    )
}

ExtendModal.propTypes = {
    isExtendModalVisible: PropTypes.bool.isRequired,
    setIsExtendModalVisible: PropTypes.func.isRequired
}

export default ExtendModal
